module.exports = __webpack_public_path__ + "img/5.1137a4ad.jpg";